import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-6 mb-5"
}
const _hoisted_3 = { class: "card mb-5 mb-xl-10" }
const _hoisted_4 = {
  "aria-controls": "kt_account_connected_accounts",
  "aria-expanded": "true",
  class: "card-header border-0 cursor-pointer",
  "data-bs-target": "#kt_account_connected_accounts",
  "data-bs-toggle": "collapse",
  role: "button"
}
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "fw-bolder m-0" }
const _hoisted_7 = {
  id: "kt_account_connected_accounts",
  class: "collapse show"
}
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = { class: "d-flex flex-stack" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder-open fs-1 w-30px me-6" }, null, -1)
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_15 = { class: "d-flex justify-content-end" }
const _hoisted_16 = { class: "form-check form-check-solid form-switch" }
const _hoisted_17 = ["onChange"]
const _hoisted_18 = ["onChange"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_21 = { class: "d-flex flex-stack" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line fs-1 w-30px me-6" }, null, -1)
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = { class: "form-check form-check-solid form-switch" }
const _hoisted_28 = ["onChange"]
const _hoisted_29 = ["onChange"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "googleswitch"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_32 = { class: "d-flex flex-stack" }
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-poll fs-1 w-30px me-6" }, null, -1)
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_37 = { class: "d-flex justify-content-end" }
const _hoisted_38 = { class: "form-check form-check-solid form-switch" }
const _hoisted_39 = ["onChange"]
const _hoisted_40 = ["onChange"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_43 = { class: "d-flex flex-stack" }
const _hoisted_44 = { class: "d-flex" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marked-alt fs-1 w-30px me-6" }, null, -1)
const _hoisted_46 = { class: "d-flex flex-column" }
const _hoisted_47 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_48 = { class: "d-flex justify-content-end" }
const _hoisted_49 = { class: "form-check form-check-solid form-switch" }
const _hoisted_50 = ["onChange"]
const _hoisted_51 = ["onChange"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_54 = { class: "d-flex flex-stack" }
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-1 w-30px me-6" }, null, -1)
const _hoisted_57 = { class: "d-flex flex-column" }
const _hoisted_58 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_59 = { class: "d-flex justify-content-end" }
const _hoisted_60 = { class: "form-check form-check-solid form-switch" }
const _hoisted_61 = ["onChange"]
const _hoisted_62 = ["onChange"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_65 = { class: "d-flex flex-stack" }
const _hoisted_66 = { class: "d-flex" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-1 w-30px me-6" }, null, -1)
const _hoisted_68 = { class: "d-flex flex-column" }
const _hoisted_69 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_70 = { class: "d-flex justify-content-end" }
const _hoisted_71 = { class: "form-check form-check-solid form-switch" }
const _hoisted_72 = ["onChange"]
const _hoisted_73 = ["onChange"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_76 = { class: "d-flex flex-stack" }
const _hoisted_77 = { class: "d-flex" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users fs-1 w-30px me-6" }, null, -1)
const _hoisted_79 = { class: "d-flex flex-column" }
const _hoisted_80 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_81 = { class: "d-flex justify-content-end" }
const _hoisted_82 = { class: "form-check form-check-solid form-switch" }
const _hoisted_83 = ["onChange"]
const _hoisted_84 = ["onChange"]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_87 = { class: "d-flex flex-stack" }
const _hoisted_88 = { class: "d-flex" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sitemap fs-1 w-30px me-6" }, null, -1)
const _hoisted_90 = { class: "d-flex flex-column" }
const _hoisted_91 = {
  class: "fs-5 text-dark text-hover-primary fw-bolder",
  href: "#"
}
const _hoisted_92 = { class: "d-flex justify-content-end" }
const _hoisted_93 = { class: "form-check form-check-solid form-switch" }
const _hoisted_94 = ["onChange"]
const _hoisted_95 = ["onChange"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_98 = { class: "d-flex flex-stack" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye fs-1 w-30px me-6" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "fs-5 text-dark text-hover-primary fw-bolder",
      href: "#"
    }, "Enquête")
  ])
], -1)
const _hoisted_100 = { class: "d-flex justify-content-end" }
const _hoisted_101 = { class: "form-check form-check-solid form-switch" }
const _hoisted_102 = ["onChange"]
const _hoisted_103 = ["onChange"]
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_106 = { class: "d-flex flex-stack" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-pie fs-1 w-30px me-6" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "fs-5 text-dark text-hover-primary fw-bolder",
      href: "#"
    }, "Statistiques")
  ])
], -1)
const _hoisted_108 = { class: "d-flex justify-content-end" }
const _hoisted_109 = { class: "form-check form-check-solid form-switch" }
const _hoisted_110 = ["onChange"]
const _hoisted_111 = ["onChange"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1)
const _hoisted_113 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_114 = { class: "btn btn-white btn-active-light-primary me-2" }
const _hoisted_115 = ["onClick"]
const _hoisted_116 = { class: "indicator-label" }
const _hoisted_117 = { class: "indicator-progress" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_119 = { class: "indicator-validate" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-check f-5 ms-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.userTypes, (usertype) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: usertype.id
      }, [
        (usertype.position !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(usertype.label), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("pages.dashboard.drive")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            (usertype.services.indexOf('drive') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('drive', usertype.id))
                                }, null, 40, _hoisted_17))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('drive', usertype.id))
                                }, null, 40, _hoisted_18)),
                            _hoisted_19
                          ])
                        ])
                      ]),
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("a", _hoisted_25, _toDisplayString(_ctx.$t("pages.dashboard.attendanceMonitoring")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (usertype.services.indexOf('attendance') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('attendance', usertype.id))
                                }, null, 40, _hoisted_28))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('attendance', usertype.id))
                                }, null, 40, _hoisted_29)),
                            _hoisted_30
                          ])
                        ])
                      ]),
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("a", _hoisted_36, _toDisplayString(_ctx.$t("pages.dashboard.results")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            (usertype.services.indexOf('results') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('results', usertype.id))
                                }, null, 40, _hoisted_39))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('results', usertype.id))
                                }, null, 40, _hoisted_40)),
                            _hoisted_41
                          ])
                        ])
                      ]),
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("a", _hoisted_47, _toDisplayString(_ctx.$t("pages.roadmap.title")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            (usertype.services.indexOf('roadmap') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('roadmap', usertype.id))
                                }, null, 40, _hoisted_50))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('roadmap', usertype.id))
                                }, null, 40, _hoisted_51)),
                            _hoisted_52
                          ])
                        ])
                      ]),
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("a", _hoisted_58, _toDisplayString(_ctx.$t("pages.ideas.title")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            (usertype.services.indexOf('ideas_box') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('ideas_box', usertype.id))
                                }, null, 40, _hoisted_61))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('ideas_box', usertype.id))
                                }, null, 40, _hoisted_62)),
                            _hoisted_63
                          ])
                        ])
                      ]),
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _hoisted_67,
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("a", _hoisted_69, _toDisplayString(_ctx.$t("pages.usefulTraining.title")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            (usertype.services.indexOf('useful-training') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('useful-training', usertype.id))
                                }, null, 40, _hoisted_72))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('useful-training', usertype.id))
                                }, null, 40, _hoisted_73)),
                            _hoisted_74
                          ])
                        ])
                      ]),
                      _hoisted_75,
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _hoisted_78,
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("a", _hoisted_80, _toDisplayString(_ctx.$t("pages.dashboard.users")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            (usertype.services.indexOf('users') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('users', usertype.id))
                                }, null, 40, _hoisted_83))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('users', usertype.id))
                                }, null, 40, _hoisted_84)),
                            _hoisted_85
                          ])
                        ])
                      ]),
                      _hoisted_86,
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _hoisted_89,
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("a", _hoisted_91, _toDisplayString(_ctx.$t("pages.dashboard.entities")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            (usertype.services.indexOf('entities') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('entities', usertype.id))
                                }, null, 40, _hoisted_94))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('entities', usertype.id))
                                }, null, 40, _hoisted_95)),
                            _hoisted_96
                          ])
                        ])
                      ]),
                      _hoisted_97,
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            (usertype.services.indexOf('survey') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('survey', usertype.id))
                                }, null, 40, _hoisted_102))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('survey', usertype.id))
                                }, null, 40, _hoisted_103)),
                            _hoisted_104
                          ])
                        ])
                      ]),
                      _hoisted_105,
                      _createElementVNode("div", _hoisted_106, [
                        _hoisted_107,
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("div", _hoisted_109, [
                            (usertype.services.indexOf('statistics') !== -1)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  checked: "",
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('statistics', usertype.id))
                                }, null, 40, _hoisted_110))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "form-check-input w-40px h-20px",
                                  type: "checkbox",
                                  onChange: ($event: any) => (_ctx.switchServices('statistics', usertype.id))
                                }, null, 40, _hoisted_111)),
                            _hoisted_112
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("button", _hoisted_114, _toDisplayString(_ctx.$t("general.cancel")), 1),
                    _createElementVNode("button", {
                      ref_for: true,
                      ref: 'submitButton' + usertype.id,
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.updateUserType(usertype, _ctx.$refs['submitButton' + usertype.id]))
                    }, [
                      _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$t("general.save")), 1),
                      _createElementVNode("span", _hoisted_117, [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.pleaseWait")) + " ", 1),
                        _hoisted_118
                      ]),
                      _createElementVNode("span", _hoisted_119, [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.done")) + " ", 1),
                        _hoisted_120
                      ])
                    ], 8, _hoisted_115)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}